import request from "../utils/fetch";
import { paramsToUrl } from "@/utils/paramsToUrl";

//合伙人列表
export function partnerList(data) {
  return request({
    url: "/user/partner/pc/company/list" + paramsToUrl(data),
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
